/**
 * Auth Slice
 * Manages authentication state
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogged: false,
  token: '',
  role: '',
  isAdmin: false,
  user: null,
  role_name: '',
  name: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLogged = true;
      // Support both token and accessToken
      state.token = action.payload.token || action.payload.accessToken || '';
      // Support both role_id and role
      state.role = action.payload.role_id || action.payload.role || '';
      // Support both isSuperAdmin and isAdmin
      state.isAdmin = action.payload.isSuperAdmin || action.payload.isAdmin || false;
      // Support user in various formats
      state.user = action.payload.user || action.payload.userData || action.payload;
      state.role_name = action.payload.role_name || '';
      state.name = action.payload.name || '';
    },
    logout: (state) => {
      state.isLogged = false;
      state.token = '';
      state.role = '';
      state.isAdmin = false;
      state.user = null;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
});

export const { login, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;

